module.exports = __webpack_public_path__ + "img/泡沫轴大腿前侧滚动右.a1aaf4d9.png";